export const checkinModalConversation = {
  guestFallback: "ضيف",
  conversationLabel: "المحادثة:",
  replyOnWhatsAppLabel: "الرد عبر واتساب:",
  replyOnWhatsAppTooltip: "الرد عبر واتساب",
};
